/**
 * The iuvo mark (carbon-shell.js `#mark`): a four-point star in a dot field.
 * It is a brand asset, so it keeps its own Soft Green fill in both themes;
 * this file is on the §8.3 literal-color allowlist for that reason. Leads the
 * Command Center nav item, the provenance line and "Guardian's read".
 */
import clsx from 'clsx'

export interface IuvoMarkProps {
  size?: number
  /** Accessible name when the mark stands alone; decorative otherwise. */
  title?: string
  className?: string
}

const BRAND = '#76d69d'
const DOTS: Array<[number, number, number]> = [
  [0, 0, 0.12], [4, 0, 0.12], [0, 4, 0.12], [4, 4, 0.12],
  [1, 0, 0.19], [3, 0, 0.19], [0, 1, 0.19], [4, 1, 0.19],
  [0, 3, 0.19], [4, 3, 0.19], [1, 4, 0.19], [3, 4, 0.19],
  [2, 0, 0.31], [0, 2, 0.31], [4, 2, 0.31], [2, 4, 0.31],
  [1, 1, 0.31], [3, 1, 0.31], [1, 3, 0.31], [3, 3, 0.31],
]

export function IuvoMark({ size = 16, title, className }: IuvoMarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.5 -0.5 5 5"
      width={size}
      height={size}
      focusable="false"
      className={clsx('flex-none', className)}
      {...(title ? { role: 'img', 'aria-label': title } : { 'aria-hidden': true })}
    >
      <path
        fill={BRAND}
        d="M1.5 1 A0.5 0.5 0 0 1 2.5 1 A0.5 0.5 0 0 0 3 1.5 A0.5 0.5 0 0 1 3 2.5 A0.5 0.5 0 0 0 2.5 3 A0.5 0.5 0 0 1 1.5 3 A0.5 0.5 0 0 0 1 2.5 A0.5 0.5 0 0 1 1 1.5 A0.5 0.5 0 0 0 1.5 1 Z"
      />
      <g fill={BRAND}>
        {DOTS.map(([cx, cy, r]) => (
          <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={r} />
        ))}
      </g>
    </svg>
  )
}

export default IuvoMark
